export enum ROLES {
    DEVELOPER =  'DEVELOPER',
    DEBUGGER = 'DEBUGGER'
}